/**
 * chatbot-widget.js — <chatbot-widget> Web Component
 * Floating chat button (bottom-right) with lazy-loaded iframe panel.
 */

class ChatbotWidget extends HTMLElement {
  connectedCallback() {
    const providerUrl = this.getAttribute('provider-url');
    const position = this.getAttribute('position') || 'bottom-right';
    const label = this.getAttribute('label') || 'Chat with us';

    this.innerHTML = `
      <button class="chatbot-widget__trigger" aria-label="${label}" aria-expanded="false" aria-controls="chatbot-panel">
        <svg class="icon icon--lg chatbot-icon-open" aria-hidden="true"><use href="${window.iconSpriteUrl || ''}#icon-chat"></use></svg>
        <svg class="icon icon--lg chatbot-icon-close" aria-hidden="true" style="display:none"><use href="${window.iconSpriteUrl || ''}#icon-close"></use></svg>
      </button>
      <div class="chatbot-widget__panel" id="chatbot-panel" role="dialog" aria-modal="true" aria-label="${label}" hidden>
        <div class="chatbot-widget__panel-header">
          <span>${label}</span>
          <button class="chatbot-widget__panel-close" aria-label="Close chat">✕</button>
        </div>
        <div class="chatbot-widget__iframe-wrap">
          <!-- iframe loaded lazily on first open -->
        </div>
      </div>`;

    this.classList.add(`chatbot-widget--${position}`);

    this._trigger = this.querySelector('.chatbot-widget__trigger');
    this._panel = this.querySelector('.chatbot-widget__panel');
    this._iframeWrap = this.querySelector('.chatbot-widget__iframe-wrap');
    this._iconOpen = this.querySelector('.chatbot-icon-open');
    this._iconClose = this.querySelector('.chatbot-icon-close');
    this._loaded = false;

    this._trigger.addEventListener('click', () => this._toggle(providerUrl));
    this.querySelector('.chatbot-widget__panel-close').addEventListener('click', () => this._close());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this._panel.hidden) this._close();
    });
  }

  _toggle(url) {
    if (this._panel.hidden) {
      this._open(url);
    } else {
      this._close();
    }
  }

  _open(url) {
    this._panel.removeAttribute('hidden');
    this._trigger.setAttribute('aria-expanded', 'true');
    this._iconOpen.style.display = 'none';
    this._iconClose.style.display = '';

    if (!this._loaded && url) {
      const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.className = 'chatbot-widget__iframe';
      iframe.setAttribute('title', 'Chat support');
      iframe.setAttribute('allow', 'microphone; camera');
      this._iframeWrap.appendChild(iframe);
      this._loaded = true;
    }
  }

  _close() {
    this._panel.setAttribute('hidden', '');
    this._trigger.setAttribute('aria-expanded', 'false');
    this._iconOpen.style.display = '';
    this._iconClose.style.display = 'none';
    this._trigger.focus();
  }
}

customElements.define('chatbot-widget', ChatbotWidget);
